/* ========================================================================
 * Stores pages
 * ======================================================================== */

import $ from "jquery";
import InitMap from "./maps";
import GeoHelper from "./geohelper";
import General from "./general";
import "../vendor/bootstrap/collapse";
import "../vendor/bootstrap/transition";



function init() {
	if ($(".stores").length === 0) {
		return;
	}

	const openedStores = document.querySelectorAll(".store.open");
	for (const openedStore of openedStores) {
		const mapContainer = openedStore.querySelector(".map-container.google-map");
		if (mapContainer && !mapContainer.querySelector(".maps-link")) {
			InitMap([mapContainer]);
			break;
		}
	}

	var $accordion = $("#stores-accordion");

	/**
	 * Adds or removes the class 'open' to a store.
	 * The class is used to control visual css styles, not bootstrap js functionality.
	 *
	 * @param  {event} e - Event object from bootstrap event
	 */
	function toggleState(e) {
		$(e.target)
			.closest(".store")
			.toggleClass("open");
	}

	//Toggle visual styles based on store open/closed state
	$accordion.on("show.bs.collapse", toggleState);
	$accordion.on("hide.bs.collapse", toggleState);

	function getScrollCompensation() {
		var scrollCompensation = ($(".header-ticker").height() || 0) + parseFloat(($(".store.open").css("padding-top") || 0));
		var $siteHeader = $(".tiny-header");
		if ($siteHeader.css("position") === "fixed") {
			scrollCompensation += $siteHeader.height();
		}

		return scrollCompensation;
	}


	//When initMap is first called, most stores are closed and the map won't initiate properly.
	//Call initMap again when store is shown.
	$accordion.on("shown.bs.collapse", function (e) {
		var $store = $(e.target).closest(".store");
		// Hide other opened stores
		$store
			.siblings(".open")
			.find(".collapse")
			.collapse("hide");
		// Init map

		const store = $store[0];
		if (store) {
			const mapContainer = store.querySelector(".map-container.google-map");

			if (mapContainer && !mapContainer.querySelector(".maps-link")) {
				InitMap([mapContainer]);
			}
		}
	});

	//Create an array of store coordinates
	var storeCoords = [];
	$(".stores .store").each(function (i, store) {
		storeCoords.push({
			id: store.id,
			lat: parseFloat($(".google-map", store).data("latitude")),
			lng: parseFloat($(".google-map", store).data("longitude"))
		});
	});


	$(window).on("load", function () {

		if (window.location.search.indexOf("?show=") !== -1) {
			//Show param opens a store by default and scrolls to it
			var $wantedStore = $(".store.open", $accordion);
			$(window).scrollTop($wantedStore.children(".store-heading").offset().top - getScrollCompensation());
		} else {
			//Determine closest store to user via geolocation
			GeoHelper.locateMe(
				function (pos) {
					//Success, compare distances between device location and stores

					for (const store of storeCoords) {

						store.distance = Math.round(
							GeoHelper.distance(
								pos.coords.latitude,
								pos.coords.longitude,
								store.lat,
								store.lng
							)
						);
					}

					//Sort stores by distance
					storeCoords.sort(General.dynamicSort("distance"));

					//Get first item and open it in accordion
					var $wantedStore = $("#" + storeCoords[0].id);

					$wantedStore
						.addClass("closest")
						.find(".collapse")
						.collapse("show");

					//Scroll down to opened item
					$(window).scrollTop(
						$wantedStore.children(".store-heading").offset().top - getScrollCompensation()
					);
				},
				function (err) {
					//Silently fail
					//Failed either because user has not allowed location or timeout
				}
			);
		}
	});
}

export default init;
